"use client";

import { SchoolData } from "@nimble/candidate-api/types";

import {
  SchoolCardActionsDesktopContainer,
  SchoolCardActionsMobileContainer,
} from "@/components/shared/school/school-card/school-card-actions.container";
import SchoolCardHeaderRow from "@/components/shared/school/school-card-header-row";
import SchoolContentBody from "@/components/shared/school/school-content-body";
import { SchoolDetailsHeaderCompact } from "@/components/shared/school/school-details/school-details-header";
import { SchoolLinkTarget } from "@/components/shared/school/school-details/school-name-link";
import SchoolJobPostings from "@/components/shared/school/school-job-postings";
import ViewSchoolPageButton from "@/components/shared/school/view-school-page-button";
import { Card, CardContent } from "@/components/ui/card";
import { schoolCardTestIds } from "@/lib/data-test-ids/schools.data-test-ids";
import { StateConfig } from "@/lib/states-config";

export default function MapSchoolCard({
  schoolData,
  stateConfig,
}: {
  schoolData: SchoolData;
  stateConfig: StateConfig;
}) {
  return (
    <Card
      className="w-full mx-auto shadow-sm rounded-lg border border-border bg-card flex flex-col py-4 min-w-120"
      data-testid={`${schoolCardTestIds.SCHOOL_CARD}-${schoolData.nces_id}`}
    >
      <CardContent className="py-1 px-4 flex-1 flex flex-col">
        <SchoolContentBody
          schoolData={schoolData}
          header={
            <SchoolCardHeaderRow
              actions={
                <SchoolCardActionsDesktopContainer
                  schoolData={schoolData}
                  stateConfig={stateConfig}
                />
              }
              mobileActions={
                <SchoolCardActionsMobileContainer
                  schoolData={schoolData}
                  stateConfig={stateConfig}
                />
              }
            >
              <SchoolDetailsHeaderCompact
                schoolData={schoolData}
                schoolLinkTarget={SchoolLinkTarget.SameTab}
                stateConfig={stateConfig}
              />
            </SchoolCardHeaderRow>
          }
          postings={
            <SchoolJobPostings
              schoolData={schoolData}
              stateConfig={stateConfig}
            />
          }
          viewButton={
            <ViewSchoolPageButton
              schoolData={schoolData}
              stateConfig={stateConfig}
            />
          }
        />
      </CardContent>
    </Card>
  );
}
